import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = { url: String, feature: String }

  private urlValue: string
  private featureValue: string

  toggle(event) {
    const checked = event.target.checked
    const feature = this.featureValue

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content
      },
      body: JSON.stringify({ feature, enabled: checked })
    })
    .then(response => response.json())
    .then(data => {
      if (!data.success) {
        event.target.checked = !checked
        alert('Failed to toggle feature. Please try again.')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      event.target.checked = !checked
      alert('An error occurred. Please try again.')
    })
  }
}